import { useState, useRef } from 'react';
import './PageStyles.css';

const ScreenplaysPage = ({ documents, onUpload, onSelect }) => {
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      onUpload(files);
    }
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      onUpload(files);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Screenplays</h1>
        <p className="page-subtitle">
          Fountain-formatted scripts with automatic rendering and professional layout
        </p>
      </div>

      <div
        className={`upload-zone ${dragOver ? 'drag-over' : ''}`}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        <div className="upload-zone-icon">◈</div>
        <div className="upload-zone-text">Drop Fountain screenplay files here</div>
        <div className="upload-zone-hint">Supports .fountain files with automatic formatting</div>
        <input
          ref={fileInputRef}
          type="file"
          accept=".fountain"
          multiple
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />
      </div>

      {documents.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">◈</div>
          <div className="empty-state-text">No screenplays yet</div>
          <div className="empty-state-hint">Upload your first Fountain screenplay to get started</div>
        </div>
      ) : (
        <div className="document-grid">
          {documents.map((doc, index) => (
            <div
              key={doc.id}
              className="document-card"
              onClick={() => onSelect(doc)}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="document-card-title">{doc.name.replace(/\.fountain$/, '')}</div>
              <div className="document-card-meta">
                {new Date(doc.uploadDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </div>
              <div className="document-card-tags">
                <span className="tag">Fountain</span>
                <span className="tag">Screenplay</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScreenplaysPage;
